'use client';
import { AuthAffordance, AuthAffordanceVariant } from '@vs-shop/commerce-ui/authAffordance';
import { useIntl } from 'react-intl';

import { authModalAtom, AuthModalMode } from '@vs-shop/engine/atom/ui/authModal';
import { useAtomSet } from '@effect/atom-react';

export default function OpenLogin() {
  const setAuthModal = useAtomSet(authModalAtom);
  const intl = useIntl();

  const handleLoginOpen = () => {
    setAuthModal({ isOpen: true, mode: AuthModalMode.login });
  };

  return (
    <AuthAffordance variant={AuthAffordanceVariant.PLAIN} onClick={handleLoginOpen}>
      {intl.formatMessage({
        id: 'component.registrationForm.switchToLogin',
        defaultMessage: 'Účet již mám, přihlásit se',
      })}
    </AuthAffordance>
  );
}
